import * as React from 'react';
import { IMaskInput } from 'react-imask';
import {
  FormControl,
  FormHelperText,
  InputBaseComponentProps,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
} from '@mui/material';
import { useRef } from 'react';

interface MaskedSocialSecurityProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const MaskedSocialSecurity = React.forwardRef<
  HTMLInputElement,
  MaskedSocialSecurityProps
>(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='XXX-XX-XXXX'
      definitions={{
        X: {
          placeholderChar: '_',
          mask: /[0-9]/,
        },
      }}
      inputRef={ref}
      unmask={true}
      onAccept={(value: string) => {
        onChange({ target: { name: props.name, value } });
      }}
      overwrite='shift'
    />
  );
});

interface MaskedSocialSecurityNumberInputProps extends OutlinedInputProps {
  value: string;
  label: string;
  name: string;
  error: boolean | undefined;
  errorText?: string;
  onValueChange: (value: string) => void;
}

export const MaskedSocialSecurityNumberInput = ({
  value,
  label,
  name,
  error,
  errorText,
  ...props
}: MaskedSocialSecurityNumberInputProps) => {
  const { onValueChange, ...rest } = props;
  const ref = useRef<HTMLInputElement>(null);

  const id = React.useId();
  const inputId = `${id}-ssn`;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onValueChange(event.target.value);
  };

  return (
    <FormControl
      variant='outlined'
      fullWidth
    >
      <InputLabel
        htmlFor={inputId}
        error={error}
      >
        {label}
      </InputLabel>
      <OutlinedInput
        inputComponent={
          MaskedSocialSecurity as unknown as React.ElementType<InputBaseComponentProps>
        }
        autoComplete='off'
        value={value}
        onChange={handleChange}
        error={error}
        name={name}
        id={inputId}
        fullWidth
        size='small'
        ref={ref}
        {...rest}
      />
      {errorText && <FormHelperText error>{errorText}</FormHelperText>}
    </FormControl>
  );
};
